import * as React from "react";

import { Portal } from "../../Common";

export const PortalToPaymentPageAboveSection: React.FunctionComponent = (props) => {
  return (
    <Portal selector=".legacy-magento-checkout-container > .legacy-magento-checkout-container--portal-above">
      {props.children || []}
    </Portal>
  );
};
